const focusableSelectors = [
  'a[href]',
  'button',
  'textarea',
  'input[type="text"]',
  'input[type="radio"]',
  'input[type="checkbox"]',
  'select',
  '[tabindex]:not([tabindex="-1"])',
];

const focusableSelectorsString = focusableSelectors.join(',');

/**
 * Imposta il focus sull'elemento successivo a quello passato come argomento.
 */
export function focusNextElement(element: Element | null) {
  if (!element) return;

  try {
    // Ottieni tutti gli elementi focusabili
    const focusableElements = Array.from(
      document.querySelectorAll(focusableSelectorsString),
    ).filter(
      el =>
        !(el as HTMLInputElement).disabled &&
        (el as HTMLElement).offsetParent !== null,
    );

    const currentIndex = focusableElements.indexOf(element);
    // Se non è stato trovato alcun elemento focusabile, annullo l'operazione
    if (currentIndex === -1) return;

    const nextElement = focusableElements[
      (currentIndex + 1) % focusableElements.length
    ] as HTMLElement;
    nextElement?.focus();
  } catch (e) {
    console.warn(
      "[ui/a11y] Si è verificato un errore durante il focus sull'elemento successivo:",
      e,
    );
  }
}
